import { adminsSlice } from '../slices';

export const { clearAdmins, setEditedUserId } = adminsSlice.actions;
